import NavigationList from './NavigationList'
import LanguageSwitcher from './LanguageSwitcher'
import UserProfile from './UserProfile'

export default function DesktopSidebar() {
	return (
		<div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
			<div className="relative flex grow flex-col gap-y-5 overflow-y-auto bg-indigo-800 px-6 after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:w-px after:bg-white/10">
				<div className="flex h-16 shrink-0 items-center">
					<img alt="CDP CRM" src="/infinity.svg" className="h-5 w-auto filter brightness-0 invert" />
					<div className="pl-2 pt-1">
						<p className="text-md font-medium text-indigo-200">CDP CRM</p>
					</div>
				</div>
				<nav className="flex flex-1 flex-col">
					<NavigationList />
					<LanguageSwitcher />
					<div className="-mx-6 mt-auto">
						<UserProfile />
					</div>
				</nav>
			</div>
		</div>
	)
}
